export default __webpack_public_path__ + "static/media/abrirtodos.a6dda2f4.svg";